module.exports = __webpack_public_path__ + "static/media/vcr.49ef39b6.jpg";